<template>
  <div class="c-table" ref="derivativeTable">
    <el-table class="common-el-table-styles" ref="table" v-loading="loading" :data="data" :height="height" border stripe>
      <slot></slot>
      <template slot="empty">
        <no-data />
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id + col.key"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button
              type="text"
              v-if="scope.row.taskFailedCnt && scope.row.taskStatus === 2"
              v-loading="scope.row.retring"
              @click="retryTask(scope.row)"
            >
              重试
            </el-button>
            <el-button type="text" v-if="scope.row.taskStatus < 2" v-loading="scope.row.stoping" @click="stopTask(scope.row)"
              >终止任务
            </el-button>
          </div>
          <span v-else-if="col.key === 'taskCnt'">{{ scope.row.taskCnting }}/{{ scope.row[col.key] }}</span>
          <span v-else-if="col.key === 'taskStatus'"
            >{{ toTaskStatus(scope.row[col.key]) }}{{ scope.row.taskFailedCnt ? `，失败${scope.row.taskFailedCnt}条` : '' }}</span
          >
          <span v-else-if="col.key === 'taskType'">{{ toType(scope.row[col.key]) }}</span>
          <span v-else-if="col.key === 'addTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'listtable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    },
    typeData: {
      type: Array
    },
    stateData: {
      type: Array
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  methods: {
    retryTask(row) {
      this.$emit('on-retry', row)
    },
    stopTask(row) {
      this.$emit('on-stop', row)
    },
    toTaskStatus(cellValue) {
      const index = this.stateData.findIndex((ret) => ret.id === cellValue)
      if (index < 0) return '未知'
      else return this.stateData[index].name
    },
    toType(cellValue) {
      const index = this.typeData.findIndex((ret) => ret.id === cellValue)
      if (index < 0) return '未知'
      else return this.typeData[index].name
    }
  }
}
</script>
